import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-specialization-for-your-m-sc-in-computer-science',
  templateUrl: './specialization-for-your-m-sc-in-computer-science.component.html',
  styleUrls: ['./specialization-for-your-m-sc-in-computer-science.component.scss']
})
export class SpecializationForYourMScInComputerScienceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
